import { ModalProps } from 'antd'

import { Popup } from 'components/Popup'

type TProps = Partial<ModalProps>

const VersionHistoryPopup = ({ children, ...rest }: TProps) => {
  return (
    <Popup width={442} footer={null} {...rest}>
      {children}
    </Popup>
  )
}

export default VersionHistoryPopup
